module.exports = __webpack_public_path__ + "img/sidebar-3.c963330b.jpg";